import React from 'react';
import { Highlight } from './Highlight';
import { MockWindow } from './MockWindow';
export function LoginMockup() {
  return <MockWindow bar={<Highlight tone="go" tag="1" data-id="element-102" data-mp="1awdic8kwmko">
          <div className="flex h-[2cqw] w-[17cqw] items-center border border-mm-light-gray bg-mm-white px-[0.8cqw] text-[1cqw] text-mm-muted-charcoal" data-id="element-103" data-mp="67d7vo6dfx67">
            dashboard.stripe.com/login
          </div>
        </Highlight>} data-id="element-101" data-mp="19l8k93ed8rz">
      <div className="flex flex-col items-center px-[2cqw] pb-[2.4cqw] pt-[1.4cqw]" data-id="element-104" data-mp="f81majzofzjm">
        <p className="self-start text-[1.4cqw] font-bold text-[#635BFF]" data-id="element-105" data-mp="k6cy309j8k4h">stripe</p>
        <div className="mt-[0.4cqw] w-[24cqw] border border-mm-light-gray bg-mm-white p-[1.6cqw] shadow-sm" data-id="element-106" data-mp="oy4iet23htm6">
          <p className="text-[1.2cqw] font-semibold text-mm-black" data-id="element-107" data-mp="tw5xz40bbasw">Sign in to your account</p>

          <p className="mb-[0.8cqw] mt-[1.2cqw] text-[1cqw] font-medium text-mm-muted-charcoal" data-id="element-108" data-mp="yxlj0w2hphba">
            Email
          </p>
          <Highlight tone="go" tag="2" data-id="element-109" data-mp="12yf6xpfxmw46">
            <div className="h-[2.3cqw] border border-mm-light-gray bg-mm-white" data-id="element-110" data-mp="3qjt8ncjniddc" />
          </Highlight>

          <div className="mb-[0.8cqw] mt-[1.2cqw] flex items-center justify-between" data-id="element-111" data-mp="3lkgr97bjtyi5">
            <span className="text-[1cqw] font-medium text-mm-muted-charcoal" data-id="element-112" data-mp="3glnbf88shvet">Password</span>
            <Highlight tone="info" data-id="element-113" data-mp="3bmtxjeplc2e4">
              <span className="text-[1cqw] font-medium text-[#635BFF]" data-id="element-114" data-mp="3bnvl2insmhcq">Forgot your password?</span>
            </Highlight>
          </div>
          <Highlight tone="go" tag="3" data-id="element-115" data-mp="d79fylgmyqg5">
            <div className="h-[2.3cqw] border border-mm-light-gray bg-mm-white" data-id="element-116" data-mp="85k3d1drm4py" />
          </Highlight>

          <Highlight tone="go" tag="4" className="mt-[1.4cqw]" data-id="element-117" data-mp="3ev95eapatn4">
            <div className="flex h-[2.4cqw] items-center justify-center bg-[#635BFF] text-[1.05cqw] font-semibold text-white" data-id="element-118" data-mp="3d0p027975k3">
              Sign in
            </div>
          </Highlight>
        </div>
      </div>
    </MockWindow>;
}